// extracted by mini-css-extract-plugin
module.exports = {"container":"MissingDetail-module_container_a3616","label":"MissingDetail-module_label_3b09f"};